import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import RandesSearch from "./pages/RandesSearch";
import Reports from "./pages/Reports";
import ReportView from "./pages/ReportView";
import { ProtectedRoute } from "./auth/ProtectedRoute";

// Single-app setup: albinsson.ai serves both the landing hub (/) and all
// tools (/randes-search, /reports, etc.). No separate subdomains per tool.
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="randes-search" element={<RandesSearch />} />
        <Route path="reports" element={<Reports />} />
        <Route path="reports/:reportId" element={<ReportView />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
